import { useEffect, useState } from "react";
import AddPatientDetails from "../dashboard/cases/addcases/AddPatientDetails";
import CloseIcon from "../assets/crossIcon.svg";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
import { RpaServices } from "../services/RpaServices";
import { fetchNewCaseNotificationCount } from "../redux/notificationSlice";
import { useDispatch } from "react-redux";
const AddNewCaseFromRpa = ({ setOpen, selectedRpaLog }) => {
  const [requestStatusUpdated, setRpaRequestStatus] = useState(false);
  const dispatch = useDispatch();
  const handleRpaRequestStatus = async () => {
    const data = {
      requestId: selectedRpaLog?.id,
      requestStatus: "COMPLETED",
      oldStatus: selectedRpaLog?.requestStatus,
      statusRemark: "Manually Updated",
    };

    if (requestStatusUpdated) {
      if (window.confirm("Do you want to add another case.")) {
        // setRpaRequestStatus(true);
      } else {
        setOpen(false);
      }
    } else {
      try {
        const response = await RpaServices.updateRpaRequest(data);
        if (response?.status === 200) {
          alert("Changes saved successfully!");
          dispatch(fetchNewCaseNotificationCount());
          if (window.confirm("Do you want to add another case.")) {
            setRpaRequestStatus(true);
          } else {
            setOpen(false);
          }
        } else {
          alert("Failed to update rpa details.");
        }
      } catch (error) {
        handleApiErrorResponses(error);
      }
    }
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);
  return (
    <div className="fixed top-0 left-0 w-screen h-screen  flex justify-center items-center bg-[#017C5780] z-[1210]">
      <div className="relative w-[80%] h-[80%] bg-white rounded-[20px] p-10">
        <div
          className="absolute top-4 right-5 cursor-pointer"
          onClick={() => setOpen(false)}
        >
          <img src={CloseIcon} alt="close-icon" />
        </div>

        <div className="h-full overflow-y-auto">
          <AddPatientDetails
            hospitalid={selectedRpaLog?.hospitalId}
            functionalityType="Add"
            handleRpaRequestStatus={handleRpaRequestStatus}
          />
        </div>
      </div>
    </div>
  );
};

export default AddNewCaseFromRpa;
